// BUILD-046 correction cycle 1bb88b3e (stage B1): the app-wide store behind the Completed filter of Team Work (oversightCompletedModel.ts). A view subscribes
// with useSyncExternalStore, calls `ensureLoaded()` when the Completed filter is chosen, `load()` after an accepted Reopen and for Retry, and `loadMore()`
// for the next page. A Caller change clears it at once; it is not read again until the view asks (the new Caller may not oversee anyone).
import { isRouteUnavailable, onCallerChanged, workApi } from '../../api/workShared';
import type { WorkTask } from '../../api/workShared';
import { createCompletedOversight } from './oversightCompletedModel';

export const completedOversight = createCompletedOversight<WorkTask>({
  getEpoch: () => workApi.getCallerEpoch(),
  fetchCompleted: (query) => workApi.listOversightCompleted(query),
  isUnavailable: isRouteUnavailable,
});

onCallerChanged(() => {
  void completedOversight.callerChanged();
});
